// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2SizM","fileDisabled":"File_fileDisabled__16ZB_"};